export const ITEM_LIST_IDS_SESSION_STORAGE_KEY = "offerListingAmplitudeItemListIds";
export const FALLBACK_SESSION_ID_SESSION_STORAGE_KEY = "offerListingAmplitudeFallbackSessionId";
export const PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY = "offerListingAmplitudePendingDetailContexts";
export const PENDING_DETAIL_CONTEXT_TTL_MS = 5 * 60 * 1000;
export const ITEM_LIST_IDS_SESSION_STORAGE_KEY = "offerListingAmplitudeItemListIds";
export const FALLBACK_SESSION_ID_SESSION_STORAGE_KEY = "offerListingAmplitudeFallbackSessionId";
export const PENDING_DETAIL_CONTEXT_LOCAL_STORAGE_KEY = "offerListingAmplitudePendingDetailContexts";
export const PENDING_DETAIL_CONTEXT_TTL_MS = 5 * 60 * 1000;
